var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;stroke:#6f7d8a;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(774 483)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-774 -483)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(771.982 480.584)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.036,22.128a2.2,2.2,0,0,1-2.2,2.2H5.2a2.2,2.2,0,0,1-2.2-2.2V6.7A2.2,2.2,0,0,1,5.2,4.5h5.509l2.2,3.305h9.916a2.2,2.2,0,0,1,2.2,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M13.5,21h6.611",
    transform: "translate(-2.788 -4.38)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.1f99d1fe22cda699e9fda40fa07e860e.svg";
export { ForwardRef as ReactComponent };